import React from 'react';
import { CAPTURE_ALWAYS_REQUIRED_FIELDS } from '../../lib/aiAttendantEngine';
import { captureChecklistFields } from '../../lib/communicationsChecklist';

function fieldLabel(field) {
    return field.replace(/_/g, ' ');
}

function IntakeCaptureChecklist({ checklist = {}, theme = 'light' }) {
    const labelCls = theme === 'dark' ? 'text-gray-400' : 'text-gray-500';
    const fields = captureChecklistFields(checklist);

    return (
        <div className="grid grid-cols-2 gap-2 text-sm">
            {fields.map((field) => {
                const item = checklist[field];
                const captured = Boolean(item?.captured);
                const required = item?.required ?? (!checklist.service_type || CAPTURE_ALWAYS_REQUIRED_FIELDS.includes(field));
                return (
                    <div key={field} className="grid min-h-12 grid-cols-[1rem_minmax(0,1fr)] grid-rows-[auto_auto] items-center gap-x-2 py-1">
                        <span className="row-span-2 self-center" aria-label={`${fieldLabel(field)} ${captured ? 'filled' : 'missing'}${required ? ', required' : ''}`}>{captured ? '✓' : '○'}</span>
                        <span className="min-w-0 capitalize leading-tight">
                            {fieldLabel(field)}
                            {required && <span aria-hidden="true" className="ml-0.5 text-red-500">*</span>}
                        </span>
                        <span className={`min-w-0 truncate text-xs leading-tight ${labelCls}`}>
                            {captured && item?.value != null ? String(item.value) : '—'}
                        </span>
                    </div>
                );
            })}
        </div>
    );
}

export default IntakeCaptureChecklist;
